// @ts-nocheck
export const typography = {
  fontFamily: "'Open Sans', sans-serif",
  fontFamilyBold: "'Open Sans', sans-serif",
  sizes: {
    h1: 40,
    h2: 32,
    h3: 20,
    body: 16,
    caption: 14,
    small: 12,
    tiny: 10,
  },
};
